const BASE_FONT_PX = 16

// pxをremに変換
export const p2r = (px: number): string => `${px / BASE_FONT_PX}rem`
